/**
 * Visual Theme registry — the overall aesthetic treatment. A few themes
 * declare personality affinity as data (compatibleWith), so e.g. Glassmorphism
 * never pairs with a Vintage brand — no if/else anywhere.
 */

export const VISUAL_THEMES = [
  { id: 'glassmorphism', name: 'Glassmorphism', compatibleWith: { brandPersonality: ['modern', 'premium', 'minimal', 'creative', 'corporate', 'sophisticated'] } },
  { id: 'neumorphism', name: 'Neumorphism', compatibleWith: { brandPersonality: ['modern', 'minimal', 'creative', 'premium'] } },
  { id: 'minimal', name: 'Minimal' },
  { id: 'gradient', name: 'Gradient' },
  { id: 'geometric', name: 'Geometric' },
  { id: 'luxury', name: 'Luxury', compatibleWith: { brandPersonality: ['luxury', 'premium', 'elegant', 'sophisticated'] } },
  { id: 'magazine', name: 'Magazine' },
  { id: 'editorial', name: 'Editorial' },
  { id: 'dark', name: 'Dark' },
  { id: 'light', name: 'Light' },
  { id: 'flat', name: 'Flat' },
  { id: 'illustration', name: 'Illustration' },
  { id: '3d', name: '3D' },
  { id: 'paper-cut', name: 'Paper Cut' },
  { id: 'organic-shapes', name: 'Organic Shapes' },
  { id: 'grunge', name: 'Grunge', compatibleWith: { brandPersonality: ['bold', 'creative', 'energetic', 'retro', 'vintage'] } },
];
